import { Logo } from '@/assets/icons/Logo';
import { Brand } from './MenuBrand.style';

const MenuBrand = (): JSX.Element => (
  <Brand>
    <Logo data-testid="menu-brand" />
  </Brand>
);

export { MenuBrand };
